import { FC, MutableRefObject } from "react";
import { Form, Input, InputRef, FormItemProps } from "antd";
import { FormattedMessage } from "react-intl";

interface InputTextProps extends FormItemProps {
  type?: "Password";
  placeholder?: string;
  label?: string;
  required?: boolean;
  autoFocus?: boolean;
  innerRef?: MutableRefObject<InputRef | null>;
}

const InputText: FC<InputTextProps> = ({
  type,
  name,
  autoFocus,
  placeholder,
  rules = [],
  required,
  label,
  innerRef,
  className,
  style,
}) => {
  const I = type ? Input[type] : Input;

  return (
    <Form.Item
      label={label && <FormattedMessage id={label} />}
      name={name}
      normalize={(value) => value.replace(/\s{2,}/g, " ")}
      rules={[
        {
          required,
          message: "Can't be blank",
        },
        ...rules,
      ]}
    >
      <I
        className={className}
        style={style}
        ref={innerRef}
        placeholder={placeholder}
        autoComplete="new-password"
        autoFocus={autoFocus}
      />
    </Form.Item>
  );
};
export default InputText;
